import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUnlinkCustomerGuestyUrl } from "./api-url.constants";
import { UnlinkCustomerGuestyError } from "./errors";

export const unlinkCustomerGuesty = async (userId?: string): Promise<void> => {
  const response = await typedFetch(getUnlinkCustomerGuestyUrl(userId), {
    method: API_METHODS.DELETE,
  });

  if (!response.ok) throw new UnlinkCustomerGuestyError();
};
